import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { KontoBankowe } from '../../../models/konto-bankowe';
import { PreviewDataWrapperComponent } from '../../preview-data-wrapper/preview-data-wrapper.component';
import { PreviewDataType } from '../../../enums/preview-data-type.enum';
import { BankAccountFormatPipe } from '../../../pipes/bank-account-format.pipe';

@Component({
  selector: 'app-preview-account-number',
  imports: [PreviewDataWrapperComponent, BankAccountFormatPipe],
  templateUrl: './preview-account-number.component.html',
  styleUrl: './preview-account-number.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewAccountNumberComponent {
  public bankAccount = input<KontoBankowe>();
  protected readonly PreviewDataType = PreviewDataType;
}
